import React, { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox, Paper } from '@mui/material';
import {
    DataGrid, GridToolbarQuickFilter, GridToolbarFilterButton,
} from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';
import { useStateIfMounted } from 'use-state-if-mounted'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { withRouter } from 'react-router-dom'
import Box from '@mui/material/Box';
import { Portal, Typography } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { ThemeProvider, createTheme } from '@mui/material/styles';

function SolicitudesEstatusUIComponent(props) {

    const rows = props?.data
    const titulo = props?.titulo

    const columns = [

        { field: 'tipoSolicitud', headerAlign: 'center', headerName: 'Tipo de solicitud', width: 200 },
        { field: 'numerosocio', headerAlign: 'center', headerName: 'No. de socio', width: 120 },
        { field: 'nombrerazonsocial', headerAlign: 'center', headerName: 'Razón social', width: 350 },
        { field: 'inspector', headerAlign: 'center', headerName: 'Inspector asignado', width: 180 },
        { field: 'cadena', headerAlign: 'center', headerName: 'Cadena Productiva', width: 320 }
    ]

    const theme = createTheme({
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
        }
    });

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                    mb: 2,
                    textAlign: 'left',
                    height: 30,
                    width: '100%',
                    backgroundColor: 'white'
                }}>
                <ThemeProvider theme={theme}>
                    <GridToolbarQuickFilter style={{ backgroundColor: '#F4F6F6', width: '100%', fontFamily: 'Montserrat' }} placeholder='Búsqueda...' />
                </ThemeProvider>            
            </Box>
        );
    }

    return (
        <Fragment>
            <div className='container'>
                <h3 className='text-center pt-2' style={{ fontWeight: 'bolder', fontFamily: 'Montserrat' }}>{titulo}</h3><br />
                <div style={{ height: 600, width: '100%', color: 'black', paddingTop: 0 }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={10}
                        components={{ Toolbar: QuickSearchToolbar }}
                        getRowHeight={() => 'auto'}
                        sx={{
                            boxShadow: 0,
                            color: 'black',
                            border: 0,
                            fontFamily: 'Montserrat',
                            '& .MuiDataGrid-cell': {
                                display: 'block',
                                position: 'relative',
                                textAlign: 'center',
                                paddingTop: '10px',
                                paddingBottom: '15px'
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#0C365A',
                                color: 'white',
                                fontFamily: 'Montserrat',
                                fontWeight: 'bold',
                                height: '20px'
                            }
                        }}
                    />
                </div>
            </div>
        </Fragment>
    )

}


export default SolicitudesEstatusUIComponent 